import React from "react";
import uniqBy from "lodash/uniqBy";
import Entity from "../../components/Entity";
import FetchData from "../../components/FetchData";
import Async from "../../core/Async";
import CourseList from "./CourseList";
import { getPlacementTestLevels } from "../../services/placementTestLevelService";

const CourseListContainer = () => (
  <FetchData service={getPlacementTestLevels}>
    {({ isFetching, data }) => (
      <Entity name="course">
        {({ getAll: getAllCourses }) => (
          <Async fetching={isFetching} color="dark" size="sm">
            <CourseList
              courses={uniqBy(
                (data || [])
                  .filter((placementLevel) => placementLevel.level >= 1)
                  .filter((placementLevel) => placementLevel.course.name.indexOf("+") < 0)
                  .sort((first, second) => {
                    if (first.level < second.level) {
                      return -1;
                    }
                    if (first.level > second.level) {
                      return 1;
                    }
                    return 0;
                  })
                  .map((placementLevel) => placementLevel.course),
                "name"
              )}
              currentCourse={getAllCourses().find((course) => !course.distributor)}
            />
          </Async>
        )}
      </Entity>
    )}
  </FetchData>
);

export default CourseListContainer;
